import React, { memo } from "react";
import { FieldArray } from "formik";
import { Grid, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { AdditionalData, Processor } from "../../../store/merchant/types";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import MerchantAdditionalDataInput from "./MerchantAdditionalDataInput";

interface MerchantAdditionalDataForm {
  index: number;
  processor: Processor;
  disabled?: boolean;
}

const MerchantAdditionalDataForm = (props: MerchantAdditionalDataForm) => {
  const { index, processor, disabled } = props;

  return (
    <FieldArray
      name={`attributes.Processor[${index}].AdditionalData`}
      render={(arrayHelpers): React.ReactElement => {
        return (
          <SectionWrapper isChild title="Additional Data">
            <Grid container spacing={2}>
              {processor?.AdditionalData?.map(
                (addtlData: AdditionalData, dataIndex: number) => {
                  return (
                    <MerchantAdditionalDataInput
                      key={dataIndex}
                      index={index}
                      dataIndex={dataIndex}
                      arrayHelpers={arrayHelpers}
                      disabled={disabled}
                    />
                  );
                }
              )}
              <Grid item xs={12}>
                <Button
                  color="primary"
                  variant="outlined"
                  size="small"
                  startIcon={<Add />}
                  disabled={disabled}
                  onClick={() =>
                    arrayHelpers.push({
                      Tag: "",
                      Value: "",
                      Encrypted: false,
                      isNew: true,
                    })
                  }
                >
                  Add Additional Data
                </Button>
              </Grid>
            </Grid>
          </SectionWrapper>
        );
      }}
    />
  );
};

export default memo(MerchantAdditionalDataForm);
